import { Controller } from '@hotwired/stimulus'
import React from 'react'
import { createRoot } from 'react-dom/client'
import JsConvertCase from 'js-convert-case'

import FastActionWidget from '../../bundles/Pilot/FastActionWidget'

export default class extends Controller {
  get props() {
    return JSON.parse(this.data.get('props'))
  }

  connect() {
    this.root = createRoot(this.element)
    this.root.render(
      <FastActionWidget
        props={JsConvertCase.camelKeys(this.props, { recursive: true, recursiveInArray: true })}
      />
    )
  }

  disconnect() {
    this.root.unmount()
  }
}
